<!-- <div style="border-top: solid 2px lightgray">
  <div class="container mt-3">
    <div class="row ">
      <section class=" col d-flex align-items " style="display: flex; align-items: center;" >
        <p class="" style="padding: 0; margin: 0;">Connect with us</p>
        <div class=" d-flex gap-3 px-2 ">
          <a href="http://www.allianz.co.id/">
            <i class="bi bi-globe-europe-africa iconFooter"></i>
          </a>
          <a href="mailto:ContactUs@allianz.co.id">
            <i class="bi bi-envelope iconFooter"></i>
          </a>
          <a href="http://www.facebook.com/AllianzIndonesia/">
            <i class="bi bi-facebook iconFooter"></i>
          </a>
          <a href="https://www.instagram.com/allianzindonesia">
            <i class="bi bi-instagram iconFooter"></i>
          </a>
          <a href="http://www.twitter.com/AllianzID">
            <i class="bi bi-twitter iconFooter"></i>
          </a>
          <a href="https://www.youtube.com/user/AllianzIndonesiaMM">
            <i class="bi bi-youtube iconFooter"></i>
          </a>
        </div>

      </section>

    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col border border-1 my-2"></div>
    </div>
  </div>

  <div class="container">
    <div class="row mb-4" style="display: flex; align-items: baseline;">
      <div class="col-md-4 col-xs-12  " >
        <p>
          Allianz dan Agen/Tenaga Penjualnya berizin dan diawasi oleh
          Otoritas Jasa Keuangan.
        </p>
      </div>
      <div class="col-md-4 col-xs-12 copyright" >
        <p>&copy; Allianz Indonesia {{ currentYear }}</p>
      </div>
      <div class="col-md-4 col-xs-12 px-2 py-2 d-flex justify-content-around gap-2 " >
        <a href="https://www.allianz.co.id/layanan/investasi0/fund-allianz/fund-fact-sheet/dplk.html"
          target="_blank">Fund Fact Sheet</a>
        |
        <a href="https://www.allianz.co.id/kebijakan-privasi.html" target="_blank">Privacy Policy</a>
        |
        <a href="https://www.allianz.co.id/term-of-use.html" target="_blank">Terms of Use</a>
      </div>
    </div>
  </div>
</div> -->

<footer class="footer">
  <div class="col-md-12 footerMainDiv">
    <ul>
      <li class="noLeftmargin">
        <a><strong>©&nbsp;&nbsp;Allianz 2017</strong></a>
      </li>
      <li>
        <a
          href="https://www.allianz.co.id/layanan/investasi0/fund-allianz/fund-fact-sheet/dplk.html"
          target="_blank"
          >Fund Fact Sheet</a
        >
      </li>
      <li>
        <a
          href="https://www.allianz.co.id/kebijakan-privasi.html"
          target="_blank"
          >Privacy Policy</a
        >
      </li>
      <li>
        <a href="https://www.allianz.co.id/term-of-use.html" target="_blank"
          >Terms of Use</a
        >
      </li>
      <li class="midFooterLi"><a>&nbsp;&nbsp;&nbsp;</a></li>
      <li class="allianzCareLi">
        <a
          ><img
            class="allianzCareImg"
            src="assets/images/ppm/allianzcare.jpg"
        /></a>
      </li>
      <li><a>Allianz Care</a></li>
      <li class="floatRight">
        <a><strong>1500-136</strong></a>
      </li>
    </ul>
  </div>
</footer>